import flex from './FlexFetch'

const awards_endpoint = '/api/1.0/awards/'

async function getDefinitions() {
  const response = await flex.flexFetch(awards_endpoint + 'definitions', {
    credentials: 'include',
  })
  return await flex.handleResponse(response)
}

async function getAllDefinitions() {
  const response = await flex.flexFetch(awards_endpoint + 'all-definitions', {
    credentials: 'include',
  })
  return await flex.handleResponse(response)
}

async function createDefinition(data) {
  const response = await flex.flexFetch(awards_endpoint + 'create-definition', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
  return await flex.handleResponse(response)
}

async function updateDefinition(data) {
  const response = await flex.flexFetch(awards_endpoint + 'update-definition', {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
  return await flex.handleResponse(response)
}

async function uploadIcon(file) {
  const formData = new FormData()
  formData.append('icon', file)

  const response = await flex.flexFetch(awards_endpoint + 'upload-icon', {
    method: 'POST',
    credentials: 'include',
    body: formData,
  })
  return await flex.handleResponse(response)
}

async function getRecentAwards(limit = 5) {
  const response = await flex.flexFetch(
    awards_endpoint + `recent?limit=${limit}`,
    {
      credentials: 'include',
    },
  )
  return await flex.handleResponse(response)
}

async function getMyAwards() {
  const response = await flex.flexFetch(awards_endpoint + 'my-awards', {
    credentials: 'include',
  })
  return await flex.handleResponse(response)
}

async function grantAward(data) {
  const response = await flex.flexFetch(awards_endpoint + 'grant', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
  return await flex.handleResponse(response)
}

async function getAutoGrantConfig() {
  const response = await flex.flexFetch(awards_endpoint + 'auto-grant-config', {
    credentials: 'include',
  })
  return await flex.handleResponse(response)
}

async function updateAutoGrantConfig(config) {
  const response = await flex.flexFetch(
    awards_endpoint + 'update-auto-grant-config',
    {
      method: 'PUT',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(config),
    },
  )
  return await flex.handleResponse(response)
}

const ApiAwards = {
  getDefinitions,
  getAllDefinitions,
  createDefinition,
  updateDefinition,
  uploadIcon,
  getRecentAwards,
  getMyAwards,
  grantAward,
  getAutoGrantConfig,
  updateAutoGrantConfig,
}

export default ApiAwards
